<template>
  <form ref="form" @submit.prevent="submit" novalidate>
    <div class="row">
      <FormControlInput
        v-model="items.cardName"
        v-validate="'required|fullname'"
        data-vv-as="Nome Impresso"
        id="name"
        name="name"
        :required="true"
        label="Nome impresso no cartão"
        icon="user"
        class="col-12"
        :error="vErrors.collect('name')"
        :valid="fields.name && fields.name.valid"
      />
    </div>

    <div class="row">
      <FormControlMask
        class="col-12"
        v-model="items.cardCpf"
        type="tel"
        label="CPF do titular"
        id="cpf"
        name="cpf"
        data-vv-as="CPF do titular"
        v-validate="{ required: true, regex: /\d{11}/ }"
        mask="###.###.###-##"
        :valid="!vErrors.has('cpf') && fields.cpf && fields.cpf.dirty && fields.cpf.valid"
        :error="vErrors.collect('cpf')"
      />
    </div>

    <div class="row">
      <FormControlMask
        v-model="items.cardNumber"
        id="cardNumber"
        type="tel"
        :required="true"
        label="Número do cartão de crédito"
        mask="#### #### #### ####"
        icon="credit-card"
        class="col-9"
        name="cardNumber"
        data-vv-as="Número"
        v-validate="'required|numeric|creditcard'"
        :valid="fields.cardNumber && fields.cardNumber.valid"
        :error="vErrors.collect('cardNumber')"
      />

      <FormControlMask
        v-model="items.cvv"
        id="cvv"
        type="tel"
        :required="true"
        label="CVV"
        class="col-3"
        mask="####"
        pattern="([0-9]{3})"
        name="cvv"
        data-vv-as="CVV"
        v-validate="'required|numeric|min:3|max:4'"
        :valid="fields.cvv && fields.cvv.valid"
        :error="vErrors.collect('cvv')"
      />
    </div>

    <div class="row direction-row vertical-center">
      <span class="row-label col-3">Vencimento</span>

      <FormControlMask
        v-model="items.month"
        id="validMonth"
        :required="true"
        label="Mês"
        class="col-4"
        mask="##"
        pattern="([0-9]{2})"
        type="tel"
        :value="items.month"
        name="month"
        data-vv-as="Mês"
        v-validate="'required|min_value:1|max_value:12'"
        :valid="fields.month && fields.month.valid"
        :error="vErrors.collect('month')"
      />

      <FormControlMask
        v-model="items.year"
        id="validYear"
        :required="true"
        label="Ano"
        class="col-4"
        mask="####"
        pattern="([0-9]{3,4})"
        type="tel"
        :value="items.year"
        name="year"
        data-vv-as="Ano"
        v-validate="'required|min:4'"
        :valid="fields.year && fields.year.valid"
        :error="vErrors.collect('year')"
      />
    </div>

    <div class="row direction-row vertical-center" v-if="!monthly">
      <span class="row-label col-3">Opções de parcelamento</span>

      <FormControlSelect
        v-model="items.parcels"
        id="parcels"
        :required="true"
        label="Selecione"
        class="col-9"
        :options="installments"
        :value="items.parcels"
        name="parcels"
        data-vv-as="Parcelas"
        v-validate="'required'"
        :valid="fields.parcels && fields.parcels.dirty && fields.parcels.valid"
        :error="vErrors.collect('parcels')"
      />
    </div>

    <div class="row align-left">
      <ButtonLink :link="{ path: `/${this.programId}/pagamento` }" class="button--option">
        Voltar
      </ButtonLink>
      <Button type="submit" :disabled="!formValid">Continuar</Button>
    </div>
  </form>
</template>

<script>
import Button from '@/components/buttons/Button.vue';
import ButtonLink from '@/components/buttons/ButtonLink.vue';
import FormControlMask from '@/components/forms/control/FormControlMask.vue';
import FormControlInput from '@/components/forms/control/FormControlInput.vue';
import FormControlSelect from '@/components/forms/control/FormControlSelect.vue';

export default {
  name: 'FormPaymentMonthly',
  data() {
    return {
      monthly: false,
      programId: this.$route.params.programId,
      flags: [
        {
          name: 'Visa',
          slug: 'visa'
        },
        {
          name: 'Master Card',
          slug: 'mastercard'
        },
        {
          name: 'Diners Club',
          slug: 'diners-club'
        }
      ],
      items: {
        parcels: null
      },
      errors: {
        valid: {}
      },
      value: null
    };
  },
  mounted() {
    const data = sessionStorage.method ? JSON.parse(sessionStorage.method) : {};
    const register = sessionStorage.register ? JSON.parse(sessionStorage.register) : {};
    const { method, value } = data;
    const { cpf, name } = register;
    this.monthly = method === 'subscription';
    this.items.cardName = name;
    this.items.cardCpf = cpf;
    this.value = value;
  },
  computed: {
    formValid() {
      return Object.keys(this.fields).every(field => {
        return this.fields[field] && this.fields[field].valid;
      });
    },
    installments() {
      const installments = Number(sessionStorage.credit_card_installments || 1);
      const value = this.value ? Number(this.value.replace(',', '.')) : 0;
      const items = [];

      for (let i = 1; i <= installments; i += 1) {
        items.push({
          slug: i,
          name: `${i}x R$ ${(value / i).toFixed(2).replace('.', ',')}`
        });
      }

      return items;
    }
  },
  components: {
    Button,
    ButtonLink,
    FormControlMask,
    FormControlInput,
    FormControlSelect
  },
  methods: {
    submit() {
      this.$emit('submit', this.items);
    }
  }
};
</script>
